import './../style/BisnessHours.css';
import './../style/Global.css';

const BisnessHours = () => {
  return (
    <div className="bg-green pt-105 pb-99">
      <div className="bisnes-hours-wrapp">
        <div>
          <div className="bisnes-item-wrapp">
            <p className='bisnes-hours-text'>Время работы</p>
            <p className='bisnes-hours-text-large'>9:00-22:00</p>
            <p className='bisnes-hours-text'>Ежедневно</p>
          </div>

        </div>
        <div>
          <div className="bisnes-item-wrapp">
            <p className='bisnes-hours-text'>Специальное предложение!</p>
            <p className='bisnes-hours-text-large ml--74'>дарим 500 ₽</p>
            <p className='bisnes-hours-text'>на первое посещение</p>
          </div>

        </div>
      </div>
    </div>
  )
}

export default BisnessHours